import { AppContext } from '../../AppContext'
import { useEffect, useContext } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

const AutoLoginTerms = () => {
	const { token } = useParams()
	const navigate = useNavigate()
	const { setUser } = useContext(AppContext)

	useEffect(() => {
		if(token){
			localStorage.setItem('userToken', token)
			setUser(null)
			navigate('/terminos-y-condiciones/')
		}
	}, [token])

	return <h2 className="center" style={{marginTop: '50px'}}>Autenticando y redirigiendo al formulario...</h2>
}
export default AutoLoginTerms